import { z } from "zod";

export const localeLanguagesSchema = z.enum(["en", "sv"]);

export type LocaleLanguages = z.infer<typeof localeLanguagesSchema>;
